export const PAGE_LIMIT = 20;

export const PAYMENT_TABS = [
  { view: 'dummy', label: 'Dummy payments' },
  { view: 'all', label: 'All transactions' },
  { view: 'inbound', label: 'Inbound' },
  { view: 'outbound', label: 'Outbound' },
  { view: 'invoices', label: 'Invoices' },
];

export const DUMMY_STATUS_HELP = {
  created:
    'Dugout created the Razorpay order. The fan has not finished checkout, or the app never called verify.',
  paid:
    'The app verified the signature. razorpay_payment_id is set and paid_at is set. This is a successful dummy payment.',
};

export function bannerCopy(keyMode) {
  if (keyMode === 'test') return 'Test mode. No real money moves.';
  if (keyMode === 'live') return 'Live mode. These charges are real.';
  if (keyMode === 'unconfigured') {
    return 'Only one of RAZORPAY_KEY_ID or RAZORPAY_KEY_SECRET is set. The table can still show older rows. If both are empty, the server uses the built-in dummy test keys and key_mode is test.';
  }
  return '';
}

/** `amount_inr` is already rupees ("99.00"). Do not divide it, and do not derive it from paise. */
export function formatRupees(amountInr) {
  if (amountInr == null || amountInr === '') return '—';
  return `₹${String(amountInr)}`;
}

export function tabCount(view, summary) {
  const count = summary?.counts?.[view];
  return count == null ? null : count;
}

export function tabAmountInr(view, summary) {
  const amounts = summary?.amounts_inr;
  if (!amounts) return null;
  if (view === 'dummy') return amounts.dummy_paid ?? null;
  if (view === 'inbound') return amounts.inbound ?? null;
  return null;
}

export function tabLabel(view, summary) {
  const tab = PAYMENT_TABS.find((item) => item.view === view);
  const name = tab?.label || view;
  const count = tabCount(view, summary);
  const amount = tabAmountInr(view, summary);
  const countText = count == null ? '' : ` (${count})`;
  const amountText = amount == null || amount === '' ? '' : ` · ${formatRupees(amount)}`;
  return `${name}${countText}${amountText}`;
}

/**
 * Inbound always lists paid orders, so a status filter is not sent.
 * Outbound and invoices are not filtered by order status either.
 */
export function transactionsQuery({ view, limit = PAGE_LIMIT, offset = 0, status, q } = {}) {
  const params = new URLSearchParams();
  params.set('view', view);
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  if ((view === 'dummy' || view === 'all') && (status === 'created' || status === 'paid')) {
    params.set('status', status);
  }
  const query = typeof q === 'string' ? q.trim() : '';
  if (query) params.set('q', query);
  return params.toString();
}

export function hasNextPage(offset, itemsLength, total) {
  return Number(offset) + Number(itemsLength) < Number(total);
}

export function emptyMessage(view, payload) {
  if (payload?.available === false) return '';
  if (view === 'dummy') return 'No dummy payments yet.';
  if (view === 'all') return 'No transactions yet.';
  if (view === 'inbound') return 'No inbound payments yet.';
  if (view === 'outbound') return 'No outbound payments yet.';
  if (view === 'invoices') return 'No invoices yet.';
  return '';
}

export function fanPrimary(user) {
  if (user == null) return 'Admin test';
  return user.name || user.username || '—';
}

/** ₹1 is 100 paise. A blank amount is an empty checkout body, which the server treats as ₹1. */
export function checkoutBody(amountRupees) {
  const raw = String(amountRupees ?? '').trim();
  if (!raw) return {};
  const paise = Math.round(Number(raw) * 100);
  if (!Number.isFinite(paise) || paise <= 0) return null;
  return { amount: paise, currency: 'INR' };
}

export function payButtonLabel(amountRupees) {
  const raw = String(amountRupees ?? '').trim();
  return `Pay ₹${raw || '1'}`;
}
